import { render, staticRenderFns } from "./AlbumUploadFormView.vue?vue&type=template&id=d2bf46fe&"
import script from "./AlbumUploadFormView.vue?vue&type=script&lang=ts&"
export * from "./AlbumUploadFormView.vue?vue&type=script&lang=ts&"
import style0 from "./AlbumUploadFormView.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports